import React from 'react';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';
import { isEmpty } from '../../../../../../../core/util/empty';

class DeductibleFamilyNonZero extends Base {
  static isVisible = ({ deductibleAmountFamilyInNetwork }: any) =>
    !isEmpty(deductibleAmountFamilyInNetwork) && parseInt(deductibleAmountFamilyInNetwork, 10) > 0;

  icon = '/images/insurance_tutorial/07_family_deductible.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>It's a family affair</H2>

            <P>
              Your family deductible works the same way. You're on the hook until you hit your{' '}
              family deductible and then benefits kick in for everyone.
            </P>

            <P>
              No family? You still might have a family deductible. Kinda weird, but there in case
              you end up needing it.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default DeductibleFamilyNonZero;
